var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E12E56",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9053234,16.9228367 C21.1958728,16.9228367 19.8106469,15.4078645 19.8106469,13.5379881 C19.8106469,11.6686759 21.1958728,10.1537037 22.9053234,10.1537037 C24.6142355,10.1537037 26,11.6686759 26,13.5379881 C26,15.4078645 24.6142355,16.923401 22.9053234,16.923401 L22.9053234,16.9228367 Z M14.7113782,23.012066 L7.92420205,15.7576905 C6.69193265,14.4402006 6.69193265,12.3045693 7.92420205,10.9876437 C8.51003008,10.3562416 9.31477169,10 10.1552667,10 C10.9957618,10 11.8005034,10.3562416 12.3863314,10.9876437 L19.1740461,18.2425835 C20.4063156,19.5595091 20.4063156,21.6957046 19.1740461,23.012066 C18.5881995,23.6436451 17.7833413,24 16.9427122,24 C16.102083,24 15.2972248,23.6436451 14.7113782,23.012066",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelo);
export default __webpack_public_path__ + "static/media/velo.10a6e04f39ad4699b02409abbfd502f5.svg";
export { ForwardRef as ReactComponent };